import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { SubTopic } from 'src/app/_models/subTopic';
import { AdminService } from 'src/app/_services/admin.service';
import { SubTopicService } from 'src/app/_services/subTopic.service';

@Component({
  selector: 'app-move-subtopic',
  templateUrl: './move-subtopic.component.html',
  styleUrls: ['./move-subtopic.component.css']
})
export class MoveSubtopicComponent implements OnInit {

  server_subtopic_id=0
  subTopic = new SubTopic()
  searchTemplateForm:FormGroup
  topicList=[]
  constructor(
    private activeRoute:ActivatedRoute,
    private router:Router,
    private subTopicService:SubTopicService,
    private adminService:AdminService) { }

  ngOnInit(): void {
    this.initForm()
    this.onChanges()
    this.activeRoute.params.subscribe(
      params=>{
        if(params['server_subtopic_id']!=0){
          this.subTopicService.getSubTopicById(params['server_subtopic_id']).subscribe(
            {
              next:(data:ResultData)=>{
                this.subTopic=data.rs.data
                this.server_subtopic_id=this.subTopic.id
            }
          }
          )
        }
      }
    )
  }

  initForm(){
    this.searchTemplateForm= new FormGroup(
       {'searchInput': new FormControl('')}
       )
   }


  onChanges(): void {
    this.searchTemplateForm.get('searchInput').valueChanges.subscribe(val => {
      if(val.length>2){

        this.adminService.searchTopics(val).subscribe(
          x=>{
            this.topicList=x
          }
        )
    }else{
      this.topicList=[]
    }
  })
}

moveSubTopic(server_template_id:number){
  this.adminService.moveSubTopicToSubTopic(server_template_id,this.server_subtopic_id).subscribe(
    x=>{
      this.router.navigate(['/admin/topic/show',this.subTopic.topic.id])
    }
  )
}
}
